import axios from "axios";

const fs = require("fs");

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    addQnaDatatoStrapi({ getters }, qnaData) {
      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: "https://cms.kcmo.arsconnect.com/qnas",
        headers: {
          "Content-Type": "application/json",
        },
        data: qnaData,
      };
      axios
        .request(config)
        .then((response) => {
          //console.log(JSON.stringify(response.data));
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addSessionDatatoStrapi({ getters }, sessionData) {
      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: "https://cms.kcmo.arsconnect.com/user-sessions",
        headers: {
          "Content-Type": "application/json",
        },
        data: sessionData,
      };
      axios
        .request(config)
        .then((response) => {
          console.log("Session Data added");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addInteractionToPostgres({ getters }, actionData) {
      let date = new Date();
      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: "https://us-central1-project-bluebox.cloudfunctions.net/analyticsPostgres/analytics",
        headers: {
          "Content-Type": "application/json",
          secret_key: "4GF7JKZ9PQ2WM6TN5XB8R1VC3LQD7FHJ",
        },
        data: {
          applicationId: getters.getKioskProfile.data().applicationId,
          sessionId: getters.getSessionId,
          actionType: actionData.actionType,
          payload: actionData.actionPayload,
          timestamp: date.toISOString(),
        },
      };
      axios
        .request(config)
        .then((response) => {
          //console.log(JSON.stringify(response.data));
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
